export const ACCOUNT_PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z]).+$/;
